import { render, staticRenderFns } from "./SingleSubscription.vue?vue&type=template&id=c9a8f054&scoped=true&"
import script from "./SingleSubscription.vue?vue&type=script&lang=ts&"
export * from "./SingleSubscription.vue?vue&type=script&lang=ts&"
import style0 from "./SingleSubscription.vue?vue&type=style&index=0&id=c9a8f054&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9a8f054",
  null
  
)

export default component.exports